<template>
  <div
    class="pt-12"
    :class="isDesktop() ? 'desktop' : 'mobile'"
  >
    <v-app-bar
      fixed
      dense
      flat
      class="grey lighten-3 abas-fixas px-md-0"
      :class="[
        !$vuetify.breakpoint.lgAndUp || 'abas-fixas--desktop',
        !$vuetify.breakpoint.md || 'abas-fixas--medium',
        !$vuetify.breakpoint.smAndDown || 'abas-fixas--mobile',
      ]"
    >
      <v-tabs
        v-model="tabs"
        :centered="$vuetify.breakpoint.smAndDown"
        :fixed-tabs="$vuetify.breakpoint.mdAndUp"
        center-active
        light
        background-color="transparent"
        style="border-bottom: 1px solid #cfd0cf;"
        @change="trocarAbas"
      >
        <v-tab
          v-for="item in items"
          :key="item.slug"
          :disabled="item.tabDisabled"
          :data-cy="`abas_${item.slug}`"
          @click="nomeDaAbaAtual = item.slug"
        >
          {{ item.tab }}
        </v-tab>
      </v-tabs>
    </v-app-bar>

    <BannersAds
      v-if="!bannerErro && bannersCompras.length > 0"
      :banners="bannersCompras"
      :width-banner="widthBanner()"
      :height-banner="heightBanner()"
      :hide-delimiters="bannersCompras.length < 2"
      :seta-banner="bannersCompras.length > 1 && $vuetify.breakpoint.smAndUp"
      class="mt-12 mb-9"
    />

    <v-tabs-items
      v-model="tabs"
      class="grey lighten-3 mt-0 pt-3"
    >
      <template v-for="(item, index) in abasContainer">
        <v-tab-item
          :key="`container=${index}`"
          :data-cy="`container_aba_${item.datacy}`"
        >
          <Loading v-if="loading" />

          <div v-else>
            <ErrorServidor v-if="erro" />

            <div v-else>
              <NenhumaCompra
                v-if="nenhumaCompra"
                :titulo="item.titulo"
              />
              <template v-else>
                <Card
                  v-if="$vuetify.breakpoint.smAndDown"
                  :dados="data"
                  @dataUpdated="trocarAbas"
                />
                <CardDesktop v-else :dados="data" @dataUpdated="trocarAbas" />
              </template>
            </div>
          </div>
        </v-tab-item>
      </template>
    </v-tabs-items>
    <div v-show="!loading && !erro">
      <div class="d-flex flex-column">
        <v-btn
          v-show="paginaAtual < totalPaginas"
          class="mt-1 mx-auto"
          text
          color="primary"
          outlined
          data-cy="btn_ver_mais"
          width="288"
          :loading="btVerMaisLoading"
          @click="verMais"
        >
          Ver mais
        </v-btn>
        <BtnIrTopo
          v-if="$vuetify.breakpoint.smAndDown"
          class="mt-5 mx-auto"
          :show="mostrarIrTopo"
          width="288"
          @change="visible => mostrarIrTopo = visible"
        />
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';

import ApiCompras from '@/api/compras';
import ApiBanners from '@/api/banners';
import Loading from '@/components/Loading.vue';
import ErrorServidor from '@/components/ErrorServidor.vue';
import BtnIrTopo from '@/components/BtnIrTopo.vue';
import NenhumaCompra from '@/components/Compras/NenhumaCompra.vue';
import Card from '@/components/Compras/Card.vue';
import CardDesktop from '@/components/Compras/CardDesktop.vue';
import BannersAds from '@/components/BannersAds.vue';
import matrixApi from '@/matrixApi';

const { mapActions, mapState, mapGetters } = createNamespacedHelpers('banners');

export default {
  name: 'Abas',

  components: {
    Loading,
    ErrorServidor,
    NenhumaCompra,
    Card,
    BtnIrTopo,
    CardDesktop,
    BannersAds,
  },

  data() {
    return {
      tabs: null,
      items: [
        { tab: 'Todos', slug: 'todos', tabDisabled: false },
        { tab: 'Produtos', slug: 'produtos', tabDisabled: true },
        { tab: 'Assinaturas', slug: 'assinaturas', tabDisabled: true },
      ],
      data: null,
      loading: true,
      erro: false,
      nenhumaCompra: true,
      mostrarIrTopo: false,
      nomeDaAbaAtual: 'todos',
      btVerMaisLoading: false,
      abasContainer: [
        {
          titulo: 'Você ainda não realizou nenhuma compra!',
          datacy: 'todos',
        },
        {
          titulo: 'Você ainda não comprou nenhum produto!',
          datacy: 'produtos',
        },
        {
          titulo: 'Você ainda não adquiriu nenhuma assinatura!',
          datacy: 'assinaturas',
        },
      ],
      paginaAtual: 0,
      totalPaginas: 0,
      itensPorPagina: 5,
      versaoLayoutDesktop: false,
      bannersCompras: [],
      bannerErro: false,
      chatError: false,
      next_batch: '',
      rooms: {},
    };
  },

  computed: {
    ...mapState(['bannerAds']),
    ...mapGetters(['getBannerAds']),
  },

  created() {
    this.versaoLayoutDesktop = this.$vuetify.breakpoint.mdAndUp;
    this.verificaStore();
  },

  methods: {
    ...mapActions(['setBannerAds']),

    async trocarAbas() {
      this.loading = true;
      this.data = [];
      this.paginaAtual = 0;
      this.totalPaginas = 0;
      this.mostrarIrTopo = false;
      await this.getApi();
      await this.getMatrixApi();
    },

    async verMais() {
      this.btVerMaisLoading = true;
      await this.getApi();
      await this.getMatrixApi();
    },

    async getApi() {
      const abaAtual = this.nomeDaAbaAtual;
      const versaoLayout = this.versaoLayoutDesktop ? 'desktop' : 'mobile';
      this.erro = false;

      await ApiCompras.orderList(abaAtual, this.paginaAtual + 1, this.itensPorPagina, versaoLayout)
        .then((response) => {
          const responseData = response.data;
          this.data = [...this.data, ...responseData.data];
          this.nenhumaCompra = this.data.length === 0;
          this.paginaAtual += 1;
          this.totalPaginas = responseData.total_pages;
          this.ativarAbas(this.data.length);
        })
        .catch(() => {
          this.erro = true;
        })
        .finally(() => {
          this.loading = false;
          this.btVerMaisLoading = false;
        });
    },

    async getMatrixApi() {
      const route = this.next_batch === '' ? 'sync' : `sync?since=${this.next_batch}`;

      await matrixApi.get(route)
        .then(({ data }) => {
          this.next_batch = data.next_batch;
          const newRooms = (data.rooms && data.rooms.join) || {};
          this.rooms = { ...this.rooms, ...newRooms };
        })
        .catch(() => {
          this.chatError = true;
        });

      if (!this.chatError) {
        this.data = this.data.map(compra => ({
          ...compra,
          notificacao_mensagem: this.notificacaoMensagem(compra),
        }));
      }
    },

    async getBannersAds() {
      await ApiBanners.bannersList('pagina-compras')
        .then((response) => {
          this.gravarStore(response.data);
        })
        .catch(() => {
          this.bannerErro = true;
        });
    },

    gravarStore(data) {
      this.bannersCompras = data;
      const dados = this.bannerAds || {};
      const banner = { paginaCompras: this.bannersCompras };

      Object.assign(dados, banner);
      this.setBannerAds(dados);
    },

    verificaStore() {
      if (this.getBannerAds('paginaCompras')) {
        this.bannersCompras = this.getBannerAds('paginaCompras');
      } else {
        this.getBannersAds();
      }
    },

    ativarAbas(quantCompras) {
      if (this.nomeDaAbaAtual === 'todos' && quantCompras > 0) {
        for (let i = 0; i < this.items.length; i += 1) {
          this.items[i].tabDisabled = false;
        }
      }
    },

    async isDesktop() {
      if (this.versaoLayoutDesktop !== this.$vuetify.breakpoint.mdAndUp) {
        this.versaoLayoutDesktop = this.$vuetify.breakpoint.mdAndUp;
        this.loading = true;
        this.data = [];
        this.paginaAtual = 0;
        this.totalPaginas = 0;
        await this.getApi();
        await this.getMatrixApi();
      }
      return this.$vuetify.breakpoint.mdAndUp;
    },

    heightBanner() {
      if (this.$vuetify.breakpoint.mdOnly) {
        return 'height: 149px';
      }
      if (this.$vuetify.breakpoint.smOnly) {
        return `height: ${(this.$vuetify.breakpoint.width * 200 / 1256)}px`;
      }
      if (this.$vuetify.breakpoint.xsOnly) {
        return `height: ${((this.$vuetify.breakpoint.width - 25) * 200 / 599)}px`;
      }
      return 'height: 199px';
    },

    widthBanner() {
      if (this.$vuetify.breakpoint.mdOnly) return 'max-width: 900px';

      return '';
    },

    notificacaoMensagem({ chat_room: chatRoom }) {
      if (!chatRoom) {
        return false;
      }

      const room = this.rooms[chatRoom];

      if (!room) {
        return false;
      }

      return room.unread_notifications.notification_count > 0;
    },
  },
};
</script>

<style lang="scss">
.abas-fixas {
  top: 48px !important;

  &--desktop {
    left: 50vw !important;
    margin-left: -564px;
    max-width: 1184px;
  }

  &--medium {
    @media(min-width: 1000px) {
      left: calc(50vw + 28px) !important;
      margin-left: -450px;
      right: auto;
      max-width: 904px;
    }

    @media(max-width: 999px) {
      left: auto !important;
      right: 12px !important;
      width: calc(100vw - 24px - 56px) !important;
    }
  }

  &--mobile { border-bottom: 1px solid #cfd0cf; }
}
</style>
